import { toast } from "sonner";

// Single source of truth for `cn` lives in @repo/utils (byte-identical impl);
// re-export it so design-system consumers keep their import path unchanged.
export { capitalize, cn } from "@repo/utils";

const parseError = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (error && typeof error === "object" && "message" in error) {
    return String(error.message);
  }

  return typeof error === "string" ? error : JSON.stringify(error);
};

export const handleError = (error: unknown): void => {
  const message = parseError(error);

  toast.error(message);
};
